module.exports = __webpack_public_path__ + "img/124.d7c72b30.jpg";